import schemas from 'src/modules/shared/yup/yupImporterSchemas';
import { i18n } from 'src/i18n';

export default [
  {
    name: 'descripcion',
    label: i18n('entities.tipoCentroCosto.fields.descripcion'),
    schema: schemas.string(
      i18n('entities.tipoCentroCosto.fields.descripcion'),
      {
        "required": true
      },
    ),
  },
  {
    name: 'habilitado',
    label: i18n('entities.tipoCentroCosto.fields.habilitado'),
    schema: schemas.boolean(
      i18n('entities.tipoCentroCosto.fields.habilitado'),
      {},
    ),
  },
  {
    name: 'centrosCostosVinculados',
    label: i18n('entities.tipoCentroCosto.fields.centrosCostosVinculados'),
    schema: schemas.relationToMany(
      i18n('entities.tipoCentroCosto.fields.centrosCostosVinculados'),
      {},
    ),
  },
];